import { forwardRef } from "react";

export const SuccessIcon = forwardRef<
    SVGSVGElement,
    React.SVGProps<SVGSVGElement>
>((props, ref) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        {...props}
        ref={ref}
    >
        <path
            d="M2.3999 8.8L5.5999 12L13.5999 4"
            stroke="currentColor"
            strokeWidth="1.336"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
));

SuccessIcon.displayName = "SuccessIcon";
